import { Box, Image, Modal, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react'
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'

import { IconArrowBackPost } from '@core/assets/icons/arrow_back_post'

import { useState } from 'react'

import { FreeMode, Navigation, Thumbs } from 'swiper/modules'

interface Props {
    isOpen: boolean
    onClose: () => void
    images: { Image: string }[]
    companyName: string
}

export const ImageGallery = ({ isOpen, onClose, images, companyName }: Props) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null)
    return (
        <Modal isOpen={isOpen} onClose={onClose} size={'xl'} isCentered={true}>
            <ModalOverlay />
            <ModalContent>
                <ModalBody px={4} py={3}>
                    <Text fontSize={'xl'} color={'text.main'} fontWeight={'semibold'} mb={3}>
                        {companyName}
                    </Text>
                    <Box position={'relative'}>
                        <Box
                            as={'div'}
                            className={'swiper-button image-swiper-button-next'}
                            position={'absolute'}
                            top={'50%'}
                            right={'-80px'}
                            transform={'translateY(-50%)'}
                            zIndex={'10'}
                        >
                            <Box
                                as={'div'}
                                w={'12'}
                                h={'12'}
                                bg={'bg.1'}
                                display={'flex'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                borderRadius={'full'}
                                boxShadow={'0px 8px 12px rgba(0, 0, 0, 0.08)'}
                                cursor={'pointer'}
                                transform={'rotate(180deg)'}
                                _hover={{
                                    backgroundColor: '#F5F5F5',
                                }}
                            >
                                <IconArrowBackPost w={'20'} h={'14'} fill={'#828282'} />
                            </Box>
                        </Box>
                        <Box
                            as={'div'}
                            className={'swiper-button image-swiper-button-prev'}
                            position={'absolute'}
                            top={'50%'}
                            left={'-80px'}
                            transform={'translateY(-50%)'}
                            zIndex={'10'}
                        >
                            <Box
                                as={'div'}
                                w={'12'}
                                h={'12'}
                                bg={'bg.1'}
                                display={'flex'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                borderRadius={'full'}
                                boxShadow={'0px 8px 12px rgba(0, 0, 0, 0.08)'}
                                cursor={'pointer'}
                                _hover={{
                                    backgroundColor: '#F5F5F5',
                                }}
                            >
                                <IconArrowBackPost w={'20'} h={'14'} fill={'#828282'} />
                            </Box>
                        </Box>
                        <Swiper
                            style={{
                                '--swiper-navigation-color': '#fff',
                                '--swiper-pagination-color': '#fff',
                            }}
                            navigation={{
                                nextEl: '.image-swiper-button-next',
                                prevEl: '.image-swiper-button-prev',
                                disabledClass: 'swiper-button-disabled',
                            }}
                            spaceBetween={10}
                            thumbs={{ swiper: thumbsSwiper }}
                            modules={[FreeMode, Navigation, Thumbs]}
                            className={'swiper_gallery'}
                            autoHeight
                        >
                            {images.map((image: { Image: string }) => (
                                <SwiperSlide key={image.Image}>
                                    <Image src={image.Image} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <Box mt={2}>
                            <Swiper
                                // @ts-ignore
                                onSwiper={setThumbsSwiper}
                                spaceBetween={8}
                                slidesPerView={8}
                                freeMode={true}
                                autoHeight
                                watchSlidesProgress={true}
                                modules={[FreeMode, Navigation, Thumbs]}
                                className={'swiper_thumbs'}
                            >
                                {images.map((image: { Image: string }) => (
                                    <SwiperSlide key={image.Image}>
                                        <Box
                                            cursor={'pointer'}
                                            transition={'all 0.3s ease'}
                                            _hover={{
                                                transform: 'scale(1.3)',
                                            }}
                                        >
                                            <Image src={image.Image} />
                                        </Box>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </Box>
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}
